<template>
  <div class="h-dialogContainer" v-if="hasReset">
    <div class="h-borderBox">
      <div class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">{{$t('SubscriberIms.impuinfoDiv')}}</div>
      <div class="h-subscriber-div-padding">
        <template>
        <BaseBusiness formId='impuinfo':formParams='formParamsUserImpuInfo' :reMountPage='reMount' :opCode='opCode' ref="impuinfo" :funcOnChange ='bindOnChangeInterface' formPattern="2"></BaseBusiness>
        </template>
      </div>
      <div id="template" class='row h-row-inputBox h-subscriber-div-padding' v-if="showTemplate">
        <div class='col-sm-6 h-col-inputBox-t'>
          <div class='h-inputLit'>{{$t('SubscriberIms.template')}}</div>
          <ejs-dropdownlist :dataSource='templateInfo' :change= "templateChange"/>
        </div>
      </div>
    </div>
    <div class="h-borderBox">
      <div class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">
        <!--{{$t('SubscriberIms.serviceProfileInfoDiv')}}-->
        <ejs-checkbox v-if="showCheckbox" :label="$t('SubscriberIms.serviceProfileInfoDiv')" @change="changeFun"></ejs-checkbox><span v-if="!showCheckbox">{{$t('SubscriberIms.serviceProfileInfoDiv')}}</span>
      </div>
      <div class="h-subscriber-div-padding">
        <template>
        <BaseBusiness formId='serviceProfileInfo':formParams='formParamsUserServiceProfileInfo' :reMountPage='reMount' :opCode='opCode' ref="serviceProfileInfo" formPattern="2"></BaseBusiness>
        </template>
      </div>
    </div>
    <div class="h-borderBox">
      <div class="h-borderBox-top" style="height: 40px; background-color: #d9d9d9;margin-bottom:10px;">
        <!--{{$t('SubscriberIms.supplementaryInfoDiv')}}-->
        <ejs-checkbox v-if="showCheckbox" :label="$t('SubscriberIms.supplementaryInfoDiv')" @change="changeSupplementFun"></ejs-checkbox><span v-if="!showCheckbox">{{$t('SubscriberIms.supplementaryInfoDiv')}}</span>
      </div>
      <div class="h-subscriber-div-padding">
        <template>
        <BaseBusiness formId='supplementaryInfo' :formParams='formParamsUserAdditionInfo' :reMountPage='reMount' :opCode='opCode' ref="supplementaryInfo" formPattern="2"></BaseBusiness>
        </template>
      </div>
    </div>
    <CustomDialog ref='qryVpnInfoPage' :element='dialog.element.eleQryVpnInfo' :styles='dialog.vpnstyles'>
      <template v-slot:dialog-content>
        <OrganizationalTree ref="organizationalTreeInner" :neid="neid" :vpndata="vpndata" :disableNodes="disableNode"></OrganizationalTree>
      </template>
    </CustomDialog>
    <CustomDialog ref='StaffInfoPage' :element='dialog.element.eleStaffInfo' :styles='dialog.staffstyles' >
      <template v-slot:dialog-content>
        <StaffInfo ref='staff' :neid="neid"></StaffInfo>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import BaseBusiness from '../U_BaseBusiness';
  import CustomDialog from '../../../../common/CustomDialog';
  import OrganizationalTree from '../../../util/OrganizationalTree';
  import StaffInfo from './StaffInfo';
  import md5 from 'js-md5';
  import SubscriberArrTool from "../../../util/parseFormNew/tools/subscriberTool";
  import { EventBus } from '../../../../../plugins/eventBus';
  import batchModCommon from '../../group/batchModCommon';


  export default {
    name: 'AddImsGroupDialog',
    components: {
      BaseBusiness,
      CustomDialog,
      OrganizationalTree,
      StaffInfo,
    },
    mixins: [batchModCommon],
    props: [
      'neid',
      'msgid',
      'opCode',
      'node'
    ],
    methods: {
      $bindRtttype(key) {
        this.funcMap.set(key, () => {
          const rtttype = this.$refs.impuinfo.$refs.bus.$refs.rtttype[0].data.value;
          setTimeout(() => {
            this.bindClickAfterPageCreated();
            this.$refs.serviceProfileInfo.$refs.bus.setData('voiceClass',0);
            this.$refs.serviceProfileInfo.$refs.bus.setData('mediaClass',0);
            this.$refs.serviceProfileInfo.$refs.bus.setData('dataClass',0);
            this.$refs.serviceProfileInfo.$refs.bus.setData('otherClass',0);
            const _dialPlan = parseInt(this.dialPlan, 0);
            if(_dialPlan === 5)//P3
            {
              if(rtttype === 2 || rtttype === 8) {
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[fleet]','hidden',true);//队号隐藏
                const validate ={range:[[100, 109], this.$t('SubscriberIms.numDialTip5')],rangeLength:[[3,3],this.$t('SubscriberIms.solid_3')]};
                this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '100~109');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '100~109');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '100~109');
              }
              else if(rtttype  === 4 || rtttype === 5 || rtttype === 6){
                const fleetOptions = [];
                for (let index = 20; index <= 89; index++) {
                  fleetOptions.push({ showName: index, value: index });
                }
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[fleet]','hidden',false);//队号显示
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[fleet]','options',fleetOptions);//队号赋值
                this.$refs.impuinfo.$refs.bus.setData('impu[fleet]',20);

                const validate ={range:[[200, 899], this.$t('SubscriberIms.numDialTip6')],rangeLength:[[3,3],this.$t('SubscriberIms.solid_3')]};
                this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '200~899');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '200~899');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '200~899');
              }
            }
            else if(_dialPlan === 6)//ZJ
            {
              if(rtttype === 2 || rtttype === 5 || rtttype === 8){
                const validate ={range:[[1, 32767], this.$t('SubscriberIms.numDialTip3')],rangeLength:[[5,5],this.$t('SubscriberIms.solid_5')]};
                this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '00001~32767');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '00001~32767');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '00001~32767');
              }
              else if(rtttype  === 4 || rtttype === 6){
                const validate ={range:[[1,32767],this.$t('SubscriberIms.numDialTip4')],rangeLength:[[5,5],this.$t('SubscriberIms.solid_5')]};
                this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '00001~29999,30019~32767');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '00001~29999,30019~32767');
                this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
                this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '00001~29999,30019~32767');
              }
            }
          }, 50);
        });
      },
      $bindZone(key) {
        this.funcMap.set(key, () => {
          const _dialPlan = parseInt(this.dialPlan, 0);
          if(_dialPlan === 4){//DMR
            const map = this.$refs.impuinfo.getDatas();
            const returnObj = {};
            Array.from(map).forEach(([key, value]) => {
              returnObj[key] = value;
            });
            if(this.checkDmrZone(returnObj['impu[zone]']))
            {
              const validate ={range:[[1,99999],this.$t('SubscriberIms.numDialTip7')],rangeLength:[[5,5],this.$t('SubscriberIms.solid_5')]};
              this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '00001~99999');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '00001~99999');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '00001~99999');
            }
            else{
              const validate ={range:[[0,99999],this.$t('SubscriberIms.numDialTip2')],rangeLength:[[5,5],this.$t('SubscriberIms.solid_5')]};
              this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '00000~99999');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '00000~99999');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '00000~99999');
            }
          }
        });
      },
      $bindFleet(key) {
        this.funcMap.set(key, () => {
          const _dialPlan = parseInt(this.dialPlan, 0);
          if(_dialPlan === 5){//P3
            const map = this.$refs.impuinfo.getDatas();
            const returnObj = {};
            Array.from(map).forEach(([key, value]) => {
              returnObj[key] = value;
            });
            if(returnObj['impu[fleet]'] >= 20 && returnObj['impu[fleet]'] <= 41)
            {
              const validate ={range:[[200,899],this.$t('SubscriberIms.numDialTip8')],rangeLength:[[3,3],this.$t('SubscriberIms.solid_3')]};
              this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '200~899');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '200~899');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '200~899');
            }
            else if(returnObj['impu[fleet]'] >= 42 && returnObj['impu[fleet]'] <= 89){
              const validate ={range:[[200,549],this.$t('SubscriberIms.numDialTip9')],rangeLength:[[3,3],this.$t('SubscriberIms.solid_3')]};
              this.$refs.impuinfo.$refs.bus.setValidate('impu[number]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[number]','placeholder', '200~549');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[startNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[startNo]','placeholder', '200~549');
              this.$refs.impuinfo.$refs.bus.setValidate('impu[endNo]',validate);
              this.$refs.impuinfo.$refs.bus.setAttrByName('impu[endNo]','placeholder', '200~549');
            }
          }
        });
      },
      checkDmrZone(zone)
      {
        if(zone === '00' ||
          zone === '10' ||
          zone === '20' ||
          zone === '30' ||
          zone === '40' ||
          zone === '50' ||
          zone === '60' ||
          zone === '70' ||
          zone === '80' ||
          zone === '90' ){
          return true;
        }
      },
      mainHandler(_data = [], propinfo, response) {
        const $this = this;
        $this.opCode = propinfo.opCode;
        $this.neid = propinfo.neid;
        $this.dialPlan = propinfo.dialPlan;
        $this.vpnclass = propinfo.vpnclass;

        const arrBase = null;
        const arrDevice = null;
        const arrServe = null;
        const res = response.data.resultVal;
        const nameMap = new Map();
        // 获取带有[]的name列表
        res.forEach((item) => {
          const { name } = item;
          if (name.indexOf('[') > -1) {
            if (typeof (nameMap.get(name.split('[')[0])) !== 'undefined') {
              const nameArray = nameMap.get(name.split('[')[0]);
              nameArray.push(item);
              nameMap.set(name.split('[')[0], nameArray);
            } else {
              const nameArr = [];
              nameArr.push(item);
              nameMap.set(name.split('[')[0], nameArr);
            }
          }
        });

        if (propinfo.opCode === 'mod') {
          this.info.vpnid = _data[0].vpnid;
          const vpntree = this.$parent.$parent.$parent.$refs.modUser.$parent.$parent.$parent.$parent.$parent.$refs.organizationalTree;
          if (_data[0].vpnid === 0) {
            if (this.node.neNode.equipmentName === undefined) {
              _data[0].vpnid = this.$t('SubscriberIms.organization');
            } else {
              _data[0].vpnid = `${this.$t('SubscriberIms.organization')}[${this.node.neNode.equipmentName}]`;
            }
          } else {
            const vpnStr = `${propinfo.neid}_7_${_data[0].vpnid}`;
            console.log(vpnStr);
            _data[0].vpnid =  vpntree.getNodeName(vpnStr);
          }
          $this.vpndata = vpntree.initData;
          $this.disableNode = vpntree.disableNode;

          if(_data[0]['regclass'] === 1){
            _data[0]['regclass'] = 0;
          }
          else if(_data[0]['regclass'] === 3){
            _data[0]['regclass'] = 1;
          }
          let voicestror = "000"+_data[0]['voiceClass'].toString(2);
          let datastror = "000000"+_data[0]['dataClass'].toString(2);
          let mediastror = "000000000000"+_data[0]['mediaClass'].toString(2);
          let otherstror = "0000000000000000000000000"+_data[0]['otherClass'].toString(2);

          voicestror = voicestror.substring(voicestror.length-3);
          datastror = datastror.substring(datastror.length-6);
          mediastror = mediastror.substring(mediastror.length-12);
          otherstror = otherstror.substring(otherstror.length-25);

          let voicestr = voicestror.split('').reverse().join('');
          let datastr = datastror.split('').reverse().join('');
          let mediastr = mediastror.split('').reverse().join('');
          let otherstr = otherstror.split('').reverse().join('');

          let voice=[];
          let data=[];
          let media=[];
          let other=[];
          voice[0] = voicestr.charAt(0);
          voice[1] = voicestr.charAt(1);
          voice[2] = voicestr.charAt(2);

          data[0] = datastr.charAt(0);
          data[1] = datastr.charAt(1);
          data[2] = datastr.charAt(2);
          data[3] = datastr.charAt(3);
          media[14] = datastr.charAt(4);
          media[15] = datastr.charAt(5);

          media[0] = mediastr.charAt(0);
          media[1] = mediastr.charAt(1);
          media[2] = mediastr.charAt(2);
          media[3] = mediastr.charAt(3);
          media[4] = mediastr.charAt(4);
          media[5] = mediastr.charAt(5);
          media[6] = mediastr.charAt(6);
          media[7] = mediastr.charAt(7);
          media[8] = mediastr.charAt(8);
          media[9] = mediastr.charAt(9);
          media[10] = mediastr.charAt(10);
          media[11] = mediastr.charAt(11);

          voice[3] = otherstr.charAt(0);
          voice[4] = otherstr.charAt(1);
          other[0] = otherstr.charAt(2);
          other[1] = otherstr.charAt(3);
          other[2] = otherstr.charAt(5);
          other[3] = otherstr.charAt(6);
          other[4] = otherstr.charAt(7);
          other[5] = otherstr.charAt(8);
          other[6] = otherstr.charAt(9);
          voice[5] = otherstr.charAt(10);
          other[7] = otherstr.charAt(11);
          other[8] = otherstr.charAt(12);
          voice[6] = otherstr.charAt(13);
          voice[7] = otherstr.charAt(14);
          media[12] = otherstr.charAt(15);
          other[9] = otherstr.charAt(16);
          other[10] = otherstr.charAt(17);
          other[11] = otherstr.charAt(18);
          voice[8] = otherstr.charAt(19);
          media[13] = otherstr.charAt(20);
          other[12] = otherstr.charAt(21);
          other[13] = otherstr.charAt(22);
          other[14] = otherstr.charAt(23);
          other[15] = otherstr.charAt(24);

          let voiceclass ='';
          voice.forEach( item => {
            voiceclass = voiceclass + item;
          });
          let dataclass ='';
          data.forEach( item => {
            dataclass =dataclass+item;
          });
          let mediaclass ='';
          media.forEach( item => {
            mediaclass = mediaclass + item;
          });
          let otherclass ='';
          other.forEach( item => {
            otherclass = otherclass + item;
          });

          _data[0]['voiceClass'] = parseInt(voiceclass.split('').reverse().join(''),2);
          _data[0]['dataClass'] = parseInt(dataclass.split('').reverse().join(''),2);
          _data[0]['mediaClass'] = parseInt(mediaclass.split('').reverse().join(''),2);
          _data[0]['otherClass'] = parseInt(otherclass.split('').reverse().join(''),2);

          _data[0]['password[origin]'] = _data[0]['password'];
          _data[0]['password[confirm]'] = _data[0]['password'];
          $this.passwordbefore = _data[0]['password'];
          $this.realmbefore = _data[0]['realm'];
          $this.lteimsibefore = _data[0]['lteimsi'];

          const sub = new SubscriberArrTool();
          const resultMap = sub.$devideByGroupBy(res,_data[0])
          $this.showTemplate = false;
          $this.initTemplateInfo();
          $this.callPageShow($this, resultMap,  arrBase, arrServe, arrDevice, propinfo);
          _data[0].vpnid = this.info.vpnid;

        } else if (propinfo.opCode === 'batchMod') {
          // $this.showTemplate = false;
          const vpntree = this.$parent.$parent.$parent.$refs.modUser.$parent.$parent.$parent.$parent.$parent.$refs.organizationalTree;
          const vpnStr = `${propinfo.neid}_7_${_data[0].vpnid}`;
          console.log(vpnStr);
         // _data[0].vpnid = vpntree.$refs.tree1.getNode(vpnStr).text;
         //  _data[0].vpnid =  vpntree.getNodeName(vpnStr);
          $this.vpndata = vpntree.initData;
          $this.disableNode = vpntree.disableNode;
          const sub = new SubscriberArrTool();
          const resultMap = sub.$devideByGroupBy(res,_data)
          $this.showTemplate = false;
          $this.showCheckbox = true;
          $this.initTemplateInfo();
          $this.callPageShow($this, resultMap, arrBase, arrServe, arrDevice, propinfo);
        } else {
          const sub = new SubscriberArrTool();
          const resultMap = sub.$devideByGroupBy(res,_data[0])
          $this.showTemplate = true;
          $this.handlerBasicInfo(propinfo, res, $this, resultMap,  arrBase, arrServe, arrDevice);
          // 获取模板信息templateInfo
          $this.initTemplateInfo();
        }
      },
      callPageShow($this, resultMap, arrBase, arrServe, arrDevice, propinfo) {
        arrBase = resultMap.get($this.formParamsUserImpuInfo.modelName);
        $this.formParamsUserImpuInfo = arrBase;
        arrDevice = resultMap.get($this.formParamsUserServiceProfileInfo.modelName);
        $this.formParamsUserServiceProfileInfo = arrDevice;
        arrServe = resultMap.get($this.formParamsUserAdditionInfo.modelName);
        $this.formParamsUserAdditionInfo = arrServe;
        setTimeout(() => {
          $this.bindClickAfterPageCreated();
          this.arrBaseBak = JSON.stringify(arrBase);
          this.arrDeviceBak = JSON.stringify(arrDevice);
          this.arrServeBak = JSON.stringify(arrServe);
          if ($this.showCheckbox) {
            $this.initState(arrBase, arrDevice, arrServe);
          }
        }, 200);
      },
      initState(arrBase, arrDevice, arrServe) {
        console.log('nogroup=', arrBase);
        console.log('arrDevice=', arrDevice);
        // this.arrBaseBak = JSON.stringify(arrBase);
        // this.arrDeviceBak = JSON.stringify(arrDevice);
        // 初始化不分组字段showName前增加checkbox
        this.bindCheckbox('impuinfo', arrBase);
        if (this.showCheckbox) {
          this.setDisabled('impuinfo', arrBase);
          this.setDisabled('serviceProfileInfo', arrDevice);
          this.setDisabled('supplementaryInfo', arrServe);
        }
      },
      /**
       * 区号、队号获取；组织架构值设置
       * @param propinfo
       * @param res
       * @returns {*}
       */

      handlerBasicInfo(propinfo, res, $this, resultMap,  arrBase, arrServe, arrDevice) {
        // 区号队号查询赋值
        this.paramForInner.vo['0'] = this.neid;
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', this.paramForInner).then((response) => {
          console.log('getZone=', response);
          if (response.status !== 200) {
            EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.requestResTip') });
          } else {
            if (response.data === '' || response.data.errorCode !== '0') {
              EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.checkZoneTip')});
            } else if (typeof (response.data) !== 'undefined' && response.data.resultVal.length > 0) {
              resultMap = $this.setParameterWithDialplan(propinfo, response, res, resultMap);
            } else {
              EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.checkZoneTip')});
            }
          }
          $this.callPageShow($this, resultMap, arrBase, arrServe, arrDevice, propinfo);
        });
      },

      setParameterWithDialplan(propinfo, response, res, resultMap) {
        // 根据拨号方案设置队号、个号的范围---包括单开、批开
        // 处理拨号方案:5 p3 4 dmr 6 zj-poc
        const _dialPlan =parseInt(propinfo.dialPlan, 0);
        const zoneOptions = [];
        const fleetOptions = [];
        const zoneRes = JSON.parse(response.data.resultVal);
        //区号,与拨号方案无关
        zoneRes.forEach((item) => {
          zoneOptions.push({ showName: item, value: item });
        });
        if(_dialPlan === 5)//P3
        {
          res.forEach((item) => {
            //区号设置
            if (item.name.indexOf('[zone]') > -1) {
              item.value = zoneOptions[0].value;
              item.options = zoneOptions;
            }
            //队号设置
            if (item.name.indexOf('[fleet]') > -1) {
              item.hidden = true;//打开页面默认终端类型为系统调度台，队号隐藏
              item.batch_hidden = true;
            }
            //个号设置
            if (item.name.indexOf('[number]') > -1 || item.name.indexOf('[startNo]') > -1 || item.name.indexOf('[endNo]') > -1) {
              if (item.validate) {
                item.validate.range = [[100, 109], this.$t('SubscriberIms.numDialTip1')];//系统调度台及ULP队号范围
                item.validate.rangeLength = [[3,3],this.$t('SubscriberIms.solid_3')]
                item.placeholder = '100~109';
              }
            }
          });

        }
        else if(_dialPlan === 4)//DMR
        {
          res.forEach((item) => {
            //区号设置
            if (item.name.indexOf('[zone]') > -1) {
              item.value = zoneOptions[0].value;
              item.options = zoneOptions;
            }
            //队号设置,DMR无队号
            if (item.name.indexOf('[fleet]') > -1) {
              item.hidden = true;//打开页面默认终端类型为系统调度台，队号隐藏
              item.batch_hidden = true;
            }
            //个号设置

            if (item.name.indexOf('[number]') > -1 || item.name.indexOf('[startNo]') > -1 || item.name.indexOf('[endNo]') > -1) {
              if(this.checkDmrZone(zoneOptions[0].value)){
                if (item.validate) {
                  item.validate.range = [[1, 99999], this.$t('SubscriberIms.numDialTip7')];
                  item.validate.rangeLength = [[5,5],this.$t('SubscriberIms.solid_5')]
                  item.placeholder = '00001~99999';
                }
              }
              else{
                if (item.validate) {
                  item.validate.range = [[0, 99999], this.$t('SubscriberIms.numDialTip2')];
                  item.validate.rangeLength = [[5,5],this.$t('SubscriberIms.solid_5')]
                  item.placeholder = '00000~99999';
                }
              }
            }
          });
        }
        else if(_dialPlan === 6)//ZJ
        {
          res.forEach((item) => {
            //区号设置
            if (item.name.indexOf('[zone]') > -1) {
              item.value = zoneOptions[0].value;
              item.options = zoneOptions;
            }
            //队号设置,ZJ无队号
            if (item.name.indexOf('[fleet]') > -1) {
              item.hidden = true;//打开页面默认终端类型为系统调度台，队号隐藏
              item.batch_hidden = true;
            }
            //个号设置，打开终端类型默认为系统调度台，各号范围为30000~30019
            if (item.name.indexOf('[number]') > -1 || item.name.indexOf('[startNo]') > -1 || item.name.indexOf('[endNo]') > -1) {
              if (item.validate) {
                item.validate.range = [[1, 32767], this.$t('SubscriberIms.numDialTip3')];
                item.validate.rangeLength = [[5,5],this.$t('SubscriberIms.solid_5')];
                item.placeholder = '00001~32767';
              }
            }
          });
        }
        res.forEach((item) => {
          if (item.name === 'vpnid') {
            item.value = propinfo.vpnname;
            this.info.vpnid = propinfo.vpnid;
            item.readonly = true;
          }
        })
        return resultMap;
      },
      /**
       * 组织架构列表查询
       * @param propinfo
       * @param res
       * @returns {*}
       */
      getVpnInfo(propinfo, $this) {
        if (this.opCode === 'batchMod' && !this.checkboxMap.vpnid) {
          return;
        }
        // 组织架构查询赋值
        this.$refs.qryVpnInfoPage.show();
        console.log('vpndata', this.vpndata);
        this.$refs.organizationalTreeInner.staDoFieldsList = this.vpndata;
        this.$refs.organizationalTreeInner.getOrganizationalTreeWithNeid();
        return;
        this.paramForInner.neId = this.neid;
        const param = {

        };
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', param).then((response) => {
          if (response.status === 200) {
            this.$refs.qryVpnInfoPage.show();
          } else {
            EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.qryVpnFailTip')});
          }
        });
      },
      initTemplateInfo() {
        this.paramForQryTemplate.neId = this.neid;
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', this.paramForQryTemplate).then((response) => {
          if (response.status === 200 && response.data.errorCode === '0') {
            const template = new Map();
            const res = JSON.parse(response.data.resultVal);
            res.result.forEach((item) => {
              template.set(item.tempnum, item.context);
              this.templateInfo.push({ text: item.tempname, value: item.tempnum });
            });
            this.templateInfoMap = template;
          }
        });
      },
      templateChange(args) {
        console.log(this.templateInfoMap.get(args.itemData.value));
        const $this = this;
        $this.$refs.serviceProfileInfo.$children[0].setDatas(JSON.parse(this.templateInfoMap.get(args.itemData.value)));
        $this.$refs.supplementaryInfo.$children[0].setDatas(JSON.parse(this.templateInfoMap.get(args.itemData.value)));
        // if (this.checkboxMap.serviceProfileInfo) {
        //
        // }
        // if (this.checkboxMap.supplementaryInfo) {
        //
        // }
      },
      getDatas() {
        const validateReturn = this.$refs.impuinfo.validateResult() === false
          ? false : (this.$refs.serviceProfileInfo.validateResult() === false
            ? false : (this.$refs.supplementaryInfo.validateResult() !== false));
        if (!validateReturn) {
          console.log('表单验证不通过');
          return;
        }
        const map = this.$refs.impuinfo.getDatas();
        const device = this.$refs.serviceProfileInfo.getDatas();
        const serve = this.$refs.supplementaryInfo.getDatas();
        const returnObj = {};
        Array.from(map).forEach(([key, value]) => {
          returnObj[key] = value;
        });
        Array.from(device).forEach(([key, value]) => {
          returnObj[key] = value;
        });
        Array.from(serve).forEach(([key, value]) => {
          returnObj[key] = value;
        });

        returnObj['vpnid'] = this.info.vpnid;
        if(this.username)
          returnObj['username'] = this.username;
        returnObj['createtime'] = Math.round(new Date() / 1000);
        console.log("createtime is ",(new Date()).valueOf());

        if(returnObj['regclass'] === 0){
          returnObj['regclass'] = 1;
        }
        else if(returnObj['regclass'] === 1){
          returnObj['regclass'] = 3;
        }

        let voicestror = "000000000"+returnObj['voiceClass'].toString(2);
        let datastror = "0000"+returnObj['dataClass'].toString(2);
        let mediastror = "0000000000000000"+returnObj['mediaClass'].toString(2);
        let otherstror = "00000000000000000"+returnObj['otherClass'].toString(2);

        let voicestr = voicestror.split('').reverse().join('');
        let datastr = datastror.split('').reverse().join('');
        let mediastr = mediastror.split('').reverse().join('');
        let otherstr = otherstror.split('').reverse().join('');

        let voice = voicestr.charAt(0)+voicestr.charAt(1)+voicestr.charAt(2);
        let data = datastr.charAt(0)+datastr.charAt(1)+datastr.charAt(2)+datastr.charAt(3)+mediastr.charAt(14)+mediastr.charAt(15);
        let media = mediastr.charAt(0)+mediastr.charAt(1)+mediastr.charAt(2)+mediastr.charAt(3)+mediastr.charAt(4)+mediastr.charAt(5)+mediastr.charAt(6)+mediastr.charAt(7)+mediastr.charAt(8)+mediastr.charAt(9)+mediastr.charAt(10)+mediastr.charAt(11);
        let other =voicestr.charAt(3)+voicestr.charAt(4)+otherstr.charAt(0)+otherstr.charAt(1)+'0'+otherstr.charAt(2)+otherstr.charAt(3)+otherstr.charAt(4)+otherstr.charAt(5)+otherstr.charAt(6)+voicestr.charAt(5)+otherstr.charAt(7)+otherstr.charAt(8)+voicestr.charAt(6)+
          voicestr.charAt(7)+mediastr.charAt(12)+otherstr.charAt(9)+otherstr.charAt(10)+otherstr.charAt(11)+voicestr.charAt(8)+mediastr.charAt(13)+otherstr.charAt(12)+otherstr.charAt(13)+otherstr.charAt(14)+otherstr.charAt(15);

        returnObj['voiceClass'] = parseInt(voice.split('').reverse().join(''),2);
        returnObj['dataClass'] = parseInt(data.split('').reverse().join(''),2);
        returnObj['mediaClass'] = parseInt(media.split('').reverse().join(''),2);
        returnObj['otherClass'] = parseInt(other.split('').reverse().join(''),2);


        console.log("voice",voice);
        console.log("data",data);
        console.log("media",media);
        console.log("other",other);

        if(this.opCode ==='mod')
        {
          if(this.passwordbefore != returnObj['password[confirm]'] || this.realmbefore != returnObj['realm'] || this.lteimsibefore != returnObj['lteimsi'])
          {
            if(returnObj['lteimsi']!=='')
              returnObj['password'] = md5(returnObj['impu']+':'+returnObj['realm'].replace('@','')+':'+returnObj['password[confirm]']+':'+returnObj['lteimsi']);
            else
              returnObj['password'] = md5(returnObj['impu']+':'+returnObj['realm'].replace('@','')+':'+returnObj['password[confirm]']);
          }
          else
          {
            returnObj['password'] = this.passwordbefore;
          }
        }
        returnObj.opCount = 1;
        return returnObj;
      },
      getGrpnumberBussiness(map) {
        // 号码拼写
        map.set('grpnum', map.get('userAlias'));
        return map;
      },
      initAnotherBussinessDatas(datas) {
        datas.confirmpassword = datas.password;
      },
      reMount() {
        this.$refs.impuinfo.reMount();
        this.$refs.serviceProfileInfo.reMount();
        this.$refs.supplementaryInfo.reMount();
      },
      getSelectList() {
        this.$refs.impuinfo.reMount();
        this.$refs.serviceProfileInfo.reMount();
        this.$refs.supplementaryInfo.reMount();
      },
      clearSelfPage() {
        this.hasReset = false;
        this.$nextTick(() => {
          this.hasReset = true;
        });
      },
      bindClickAfterPageCreated() {

        // 输入框点击事件----根据name名称找到组件
        const componentArray = this.$refs.impuinfo.$children[0].$children;
        componentArray.forEach(item => {
          if (this.opCode === 'batchMod' || this.opCode === 'mod'){
            if (item.$refs.vpnid) {
              // 输入框右侧增加"选择超链接"
              const input = document.createElement('A');
              input.onclick = this.getVpnInfo;
              input.className = 'h-subscriber-atag';
              const valueOfAtag = document.createTextNode(this.$t('SubscriberIms.selectVButton'));
              input.appendChild(valueOfAtag);
              item.$refs.vpnid.parentElement.className = 'h-subscriber-div-innerwitha_user';
              item.$refs.vpnid.parentElement.appendChild(input);
              //return null;
            }
          }
          if(this.opCode === 'add' || this.opCode === 'mod'){
            if (item.$refs.username) {
              // 输入框右侧增加"选择超链接"
              const input = document.createElement('A');
              input.onclick = this.openStaffInfo;
              input.className = 'h-subscriber-atag';
              const valueOfAtag = document.createTextNode(this.$t('SubscriberIms.selectVButton'));
              input.appendChild(valueOfAtag);
              item.$refs.username.parentElement.className = 'h-subscriber-div-innerwitha_user';
              item.$refs.username.parentElement.appendChild(input);
             // return null;
            }
          }
          return null;
        });
      },
      /**
       * 更新和关闭组织架构
       */
      setChooseVpnInfo(event) {
        if (event.keyCode === 13) {
          return;
        }
        const selectNode = this.$refs.organizationalTreeInner.getNode();
        if (!selectNode) {
          EventBus.$emit('toast', { type: 'warning', content:this.$t('SubscriberIms.chooseNodeTip')});
        } else {
          this.$refs.organizationalTreeInner.clear();
          this.$refs.qryVpnInfoPage.clear();
          this.$refs.qryVpnInfoPage.close();
          this.$refs.impuinfo.$refs.bus.getRefObj('vpnid').value=selectNode.text;
          this.$refs.impuinfo.$refs.bus.validateResult(['vpnid']);
          this.info.vpnid = selectNode.id.split('_')[2];
        }
      },
      closeQryVpnInfoPage() {
        this.$refs.organizationalTreeInner.clear();
        this.$refs.qryVpnInfoPage.clear();
        this.$refs.qryVpnInfoPage.close();
      },
      openStaffInfo() {
        this.$refs.StaffInfoPage.show();
        this.$refs.staff.getGridData(this.info.vpnid,this.vpnclass);
      },
      setStaffInfo(){
        const staffname = this.$refs.staff.getCheckedData();
        console.log("staffname:",staffname);
        this.$refs.StaffInfoPage.clear();
        this.$refs.StaffInfoPage.close();
        this.$refs.impuinfo.$refs.bus.getRefObj('username').value=staffname;
        this.$refs.impuinfo.$refs.bus.validateResult(['username']);
        if(staffname)
          this.username = staffname;
      },
      closeStaffInfo(){
        this.$refs.StaffInfoPage.clear();
        this.$refs.StaffInfoPage.close();
      },
      changeFun(args) {
        const arrDevice = JSON.parse(this.arrDeviceBak);
        if (args.checked) {
          this.setEnabled('serviceProfileInfo', arrDevice);
          this.checkboxMap.serviceProfileInfo = true;
        } else {
          this.setDisabled('serviceProfileInfo', arrDevice);
          this.checkboxMap.serviceProfileInfo = false;
        }
      },
      changeSupplementFun(args) {
        const arrServe = JSON.parse(this.arrServeBak);
        if (args.checked) {
          this.setEnabled('supplementaryInfo', arrServe);
          this.checkboxMap.supplementaryInfo = true;
        } else {
          this.setDisabled('supplementaryInfo', arrServe);
          this.checkboxMap.supplementaryInfo = false;
        }
      },
      changeBaseFun(args, dom) {
        const arrBaseInfo = JSON.parse(this.arrBaseBak);
        if (args === undefined) {
          return;
        }
        console.log(args, dom);
        const name = args.path[5].__vue__.data.name;
        const arrBase = arrBaseInfo.filter((item) => item.name === name);
        if (args.target.checked) {
          this.setEnabled('impuinfo', arrBase);
          this.checkboxMap[name] = true;
        } else {
          this.setDisabled('impuinfo', arrBase);
          this.checkboxMap[name] = false;
        }
      },
    },
    data() {
      return {
        funcMap:'',
        vpndata: [],
        disableNode:[],
        hasReset: true,
        showTemplate: true,
        showCheckbox: false,
        arrBaseBak: undefined,
        arrDeviceBak: undefined,
        arrServeBak: undefined,
        checkboxMap: {
          serviceProfileInfo: false,
           supplementaryInfo: false
        },
        templateInfo: [], // 宽带模板列表
        templateInfoMap: {}, // 模板信息缓存
        dialPlan: '',
        neid:'',
        passwordbefore:'',
        realmbefore:'',
        lteimsibefore:'',
        rtttypeRef: undefined,
        info: {
          vpnid: '',
        },
        vpnclass:'',
        paramForQryTemplate: {
          vo: {
            0: { page: '1', pageSize: 1000 },
            1: { neid: this.neid, tempname: '', temptype: 1, neid: this.neid }
          },
          info: {
            neId: this.neid,
            operation: 'qryTemplate'
          },
          page: {
            pageNo: 1,
            pageSize: 1000
          }
        },
        username:'',
        formParamsUserImpuInfo: {
          json: '',
          formId: `${this.opCode}impuinfoBussiness`,
          subObject: '',
          modelName: 'impuinfo',
        },
        formParamsUserServiceProfileInfo: {
          json: '',
          formId: `${this.opCode}serviceProfileInfoBussiness`,
          subObject: '',
          modelName: 'serviceProfileInfo',
        },
        formParamsUserAdditionInfo: {
          json: '',
          formId: `${this.opCode}supplementaryInfoBussiness`,
          subObject: '',
          modelName: 'supplementaryInfo',
        },
        paramForGetJson: {
          msgid: this.msgid,
          neid: this.neid
        },
        paramForInner: {
          vo: {
            0: this.neid,
            1: 'TcfRegionNum',
            2: 'RegionNum'
          },
          info: {
            neId: this.neid,
            operation: 'getZone'
          }
        },
        operetion: {
          getZone: 'getZone'
        },
        dialog: {
          vpnstyles: {
            width: '20%',
            height: '38%',
            zIndex:1212,
            visible: false,
            model: true
          },
          staffstyles: {
            width: '75%',
            height: '60%',
            zIndex:1212,
            visible: false,
            model: true
          },
          element: {
            eleQryVpnInfo: {
              target: this.$refs.qryVpnInfoPage,
              refName: 'qryVpninfo',
              buttonGroup: [
                {
                  click: this.closeQryVpnInfoPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }
                },
                {
                  click: this.setChooseVpnInfo, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
                }
              ],
              title: this.$t('SubscriberIms.organization'),
              isClose: true
            },
            eleStaffInfo: {
              target: this.$refs.StaffInfoPage,
              refName: 'StaffInfo',
              buttonGroup: [
                {
                  click: this.closeStaffInfo, buttonModel: { content: this.$t('SubscriberIms.cancel') }
                },
                {
                  click: this.setStaffInfo, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
                }
              ],
              title: this.$t('SubscriberIms.staffTitle'),
              isClose: true
            }
          },
        },
      };
    },
    computed: {
      bindOnChangeInterface() {
        this.funcMap = new Map();
        this.$bindRtttype('rtttype');
        this.$bindZone('impu[zone]');
        this.$bindFleet('impu[fleet]');
        return this.funcMap;
      },
    }
  };
</script>

<style scoped>

</style>
